import OrderItemTag from "@/enum/OrderItemTag";

const OrderItemTagNameMap = {
    [OrderItemTag.DOUDIAN_ORDER_SUPPLY]: "供应链",
};

export default OrderItemTagNameMap;
